import { gql } from 'urql';

const FetchPartnerOffersCategories = gql`
  query fetchPartnerOffersCategories($categorySortBy: SortBy) {
    myPartnerOffers {
      categories(sortBy: $categorySortBy) {
        ... on PartnerOfferCategory {
          id
          name
          order
          iconKey
          iconUrl
        }
      }
    }
  }
`;

export default FetchPartnerOffersCategories;
